// import '../wdyr'

import React from 'react'
import { createRoot } from 'react-dom/client'
import { IntlProvider } from 'react-intl'
import { Provider } from 'react-redux'

import Typography from 'components/styles/Typography'

import RootContainer from './components/RootContainer'
import configureStore from './store'

import 'react-date-range/dist/styles.css' // main style file
import 'react-date-range/dist/theme/default.css' // theme css file

import 'rxjs'
import '../webpack-es6-public-path'

import * as Sentry from '@sentry/browser'

const store = configureStore()

window.IRONSCALES = {}

const container = document.getElementById('app')
const root = createRoot(container)

root.render(
  <>
    <Typography />
    <IntlProvider locale="en">
      <Provider store={store}>
        <RootContainer store={store} />
      </Provider>
    </IntlProvider>
  </>
)

export const initSentry = (env) => {
  Sentry.init({
    dsn: 'https://266f73f01f09432ebf01138bd5f050e6@o86130.ingest.sentry.io/1259170',
    release: GIT_VERSION,
    environment: env,
    ignoreErrors: [
      'ResizeObserver loop limit exceeded',
      'ResizeObserver loop completed with undelivered notifications.',
    ],
    beforeSend(event) {
      console.error(event)
      if (env === 'ONPREMISE' || window.DISABLE_SENTRY) return null
      else return event
    },
  })

  window.SENTRY_INITIALIZED = true
}

// Since CKEDITOR script coming directly from pip django-ckeditor package,
// this is the place to change the timestamp to reset the cache.
// source: https://stackoverflow.com/questions/14940452/force-ckeditor-to-refresh-config
if (CKEDITOR) {
  CKEDITOR.timestamp = +new Date()
}
